import { Component } from 'opus-angular-seed-core';

/**
 * This component is also used by quiz feedback forms for rendering questions
 */
@Component({
    bindings: {
        formSubmission: '=',
        form: '=',
        category: '=',
        openedTab: '=',
        index: '=',
        counter: '=',
        categoriesCount: '='
    },
    template: `
        <div class="block02" ng-class="{ open:vm.openedTab === vm.index }">
            <a class="scrolltop" name="questionblock{{vm.index}}"/>
            <div class="heading01">
                <h2 ng-click="vm.setActiveTab(vm.index)">
                    <span ng-if="vm.category.activeI18n.name">{{ vm.category.activeI18n.name }}</span>
                    <small>({{ vm.answeredQuestions }}/{{ vm.category.questions.length }} {{ 'evaluation.questions' | translate }})</small>
                </h2>
            </div>
            <div class="question" ng-repeat="question in vm.category.questions">
                <evaluation-public-evaluation-question-scale
                    form="vm.form"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    counter="vm.counter[question.id]"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                />
                <evaluation-public-evaluation-question-radio
                    form="vm.form"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    counter="vm.counter[question.id]"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                />
                <evaluation-public-evaluation-question-free-text
                    form="vm.form"
                    counter="vm.counter[question.id]"
                    answered-questions="vm.answeredQuestions"
                    question="question"
                    ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                />
            </div>
            <ul ng-if="vm.categoriesCount !== vm.index + 1" class="actions01">
                <li><a class="btn main" ng-click="vm.setActiveTab(vm.index + 1)">{{ 'general.Next' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($location, QUESTIONS_TYPE_ENUM) {
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.$location = $location;
        this.answeredQuestions = 0;
    }

    setActiveTab (index) {
        this.openedTab = index;
        const target = `questionblock${index}`;
        this.$location.hash(target);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/evaluation/category/index.js